import React, { useEffect } from "react";
import BlogData from "../Data/BlogData.json";
import VideoOverViewBg from "../Assets/img/blog/video-overview.jpg";
import SingleBlogImg from "../Assets/img/blog/single-blog.svg";
import { Link } from "react-router-dom";
import VideoPlayerPopup from "../Components/VideoPlayerPopup";

const BlogSingle = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area blog-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-8 col-12">
              <div className="breadcrumb-content">
                <h3>How ISP Digital takes care of your problems.</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-detail-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <div className="blog-detail-inner">
                <div className="blog-detail-head">
                  <img src={SingleBlogImg} alt="#" />
                  <ul className="blog-meta single-blog-meta">
                    <li className="dot">5/10/2021</li>
                    <li>By: Md. Imtiaj Ahamed</li>
                  </ul>
                </div>
                <div className="single-blog-menu">
                  <ul>
                    <li>
                      <Link to="/">
                        Home<i className="fa fa-chevron-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog">
                        Blog<i className="fa fa-chevron-right"></i>
                      </Link>
                    </li>
                    <li className="active">
                      <Link to="/blogsingle">
                        How ISP Digital takes care of your problems.
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-details-content">
                  <p>
                    ISP Digital is a management and billing solution designed
                    for the ISP industry which helps run ISP businesses more
                    efficiently and effectively. It assists with management and
                    billing solutions, including complete authorization,
                    operations, billing management modules, and many essential
                    features that offer smooth operation for businesses. It
                    allows companies to track the quality of service with
                    customer usage and, through this software solution, the
                    billing process can be automated by sending invoices and
                    receiving payments. ISP Digital helps to lead in a
                    competitive market by providing excellent business
                    management and a high-quality internet connection to improve
                    service quality. 
                  </p>
                  <p className="paragraph">
                    In this blog, we will highlight how ISP Digital can take
                    care of your business difficulties. Could you keep reading
                    to explore more about it?
                  </p>
                  {/* <div
                    className="video-overview"
                    style={{ backgroundImage: `url(${VideoOverViewBg})` }}
                  >
                    <div className="video-overview-content">
                      <div className="video-warp">
                        <div className="video-main">
                          <VideoPlayerPopup />
                        </div>
                      </div>
                      <span>Video Overview</span>
                    </div>
                  </div> */}

                  <p>
                    We are all human beings in our team, and we have a few
                    business principles to follow. One of the core things is to
                    be honest, and loyal to our clients. We are constantly
                    exploring ways to provide trustworthy & result-oriented
                    services to customers. At ISP Digital, we have included
                    steps with a categorized team to ensure excellence in
                    services for your business.
                  </p>
                  <div className="single-blog-details-content">
                    <h6 className="sblog-cont-title">Commercial Team</h6>
                    <p className="sblog-content-text">
                      Our commercial team is responsible for obtaining your
                      orders and for supporting distribution. To better meet the
                      client's needs, the commercial team listens to your ISP
                      business requirements. The group includes multiple
                      categories of people and resources depending on the needs.
                      The main tasks conducted by the commercial team are to
                      manage corporate dealings such as potential clients with
                      the engagement of clients' enrollment in various trade
                      programs, to take orders, financial dealings (quotations,
                      charges, packages, etc.), and conduct categorized
                      promotions or campaigns. The commercial team is also
                      responsible for presenting or sharing information about
                      the ISP Digital service with your company.
                    </p>
                  </div>
                  <div className="single-blog-details-content">
                    <h6 className="sblog-cont-title">
                      The Design & Development team:
                    </h6>
                    <p className="sblog-content-text">
                      ISP Digital completes a substantial analysis of your ISP
                      Business requirements and makes adjustments to ensure the
                      software functions properly on your end. Once the
                      investigation is complete, designing takes over, which
                      helps remove possible flaws by setting a standard model.
                      After that, our developers start the actual software
                      development process and customize it according to your ISP
                      business.
                    </p>
                  </div>
                  <div className="single-blog-details-content">
                    <h6 className="sblog-cont-title">Supporting team: </h6>
                    <p className="sblog-content-text">
                      Our support team collaborates with you and our development
                      team in the testing stage, assessing the software for
                      errors and document bugs. Also, the supporting team helps
                      in the same way while any customization is needed to
                      ensure the complete level of customer satisfaction. After
                      the software has passed all of the stages without errors,
                      it will go through a maintenance process in which it will
                      be maintained and upgraded regularly to keep up with
                      changes. Though ISP Digital is exceptionally
                      user-friendly, we ensure you get proper guidelines for
                      your business management to make you more comfortable with
                      the system.
                    </p>
                  </div>
                  <div className="single-blog-details-content">
                    <h6 className="sblog-cont-title">
                      After-sales service team:  
                    </h6>
                    <p className="sblog-content-text">
                      ISP Digital values and prioritizes keeping the commitment,
                      ensuring customer satisfaction and brand loyalty. We
                      provide proactive after-sales service individually to
                      clients. We established a fully dedicated customer service
                      team, who serve real-time 24/7 customer service to deal
                      with your business issues. Our technical support team is
                      also engaged in after-sales service to ensure the highest
                      quality of service.
                    </p>
                    <p className="sblog-content-text mt-12">
                      Moreover, ISP Digital provides service excellence with the
                      highest ability to meet and occasionally exceed our
                      customers' expectations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="blog-sidebar-main">
                <div className="sidebar-widget search-widget">
                  <form action="#">
                    <input type="text" placeholder="Search blog" />
                    <button type="submit">
                      <i className="fa fa-search"></i>
                    </button>
                  </form>
                </div>
                <div className="sidebar-widget recent-blog">
                  <h5 className="sidebar-widget-title">Recent Blog</h5>
                  <div className="recent-blog-inner">
                    {BlogData.slice(0, 4).map((SingleRecent) => (
                      <div className="single-recent-blog" key={SingleRecent.id}>
                        <div className="recent-img">
                          <img src={SingleRecent.img} alt="#" />
                        </div>
                        <div className="recent-blog-content">
                          <h6 className="r-title">
                            <Link href="/blogsingle">{SingleRecent.title}</Link>
                          </h6>
                          <ul className="blog-meta recent-blog-meta">
                            <li className="dot">{SingleRecent.date}</li>
                            <li>{SingleRecent.time}</li>
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="sidebar-widget categories">
                  <h5 className="sidebar-widget-title">Categories</h5>
                  <ul>
                    <li>
                      <a href="#">isp digital</a>
                    </li>
                    <li>
                      <a href="#">web server</a>
                    </li>
                    <li>
                      <a href="#">internet</a>
                    </li>
                    <li>
                      <a href="#">download</a>
                    </li>
                    <li>
                      <a href="#">server</a>
                    </li>
                    <li>
                      <a href="#">business statistics</a>
                    </li>
                    <li>
                      <a href="#">business logic</a>
                    </li>
                    <li>
                      <a href="#">ubuntu</a>
                    </li>
                    <li>
                      <a href="#">ui design</a>
                    </li>
                    <li>
                      <a href="#">ux design</a>
                    </li>
                    <li>
                      <a href="#">startups</a>
                    </li>
                    <li>
                      <a href="#">technology</a>
                    </li>
                    <li>
                      <a href="#">web</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogSingle;
